/*
 * Copyright (C) 2025 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { Component, Inject } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { ResourceTag } from '@app/app/shared/models';
import { FrameworkType } from '@app/app/shared/models/admin/admin.model';

export interface AddFrameworkTagsDialogData {
  isDialogPage?: boolean;
  frameworkType?: FrameworkType;
}

@Component({
  templateUrl: './add-framework-tags-dialog.component.html',
  styleUrls: ['./add-framework-tags-dialog.component.scss'],
})
export class AddFrameworkTagsDialogComponent {
  frameworkType: FrameworkType = 'STANDARD';

  constructor(
    private dialogRef: MatDialogRef<AddFrameworkTagsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AddFrameworkTagsDialogData,
  ) {
    if (data?.frameworkType) {
      this.frameworkType = data.frameworkType;
    }
  }

  closeDialog() {
    this.dialogRef.close();
  }

  onAddTags(tags: ResourceTag[]) {
    this.dialogRef.close(tags);
  }
}
